/**
 * Avril.ma — AI Skin Analyzer
 * Frontend logic: upload, send to Railway API, display results
 */

(function () {
  'use strict';

  const API_URL = window.AVRIL_API_URL || 'https://web-production-fb65c.up.railway.app';

  let selectedFile = null;

  // ---- Init ----
  document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('skin-photo-input');
    const uploadArea = document.getElementById('upload-area');

    if (!input || !uploadArea) return;

    // File input change
    input.addEventListener('change', function (e) {
      const file = e.target.files[0];
      if (file) handleFileSelected(file);
    });

    // Drag & drop
    uploadArea.addEventListener('dragover', function (e) {
      e.preventDefault();
      uploadArea.classList.add('drag-over');
    });

    uploadArea.addEventListener('dragleave', function () {
      uploadArea.classList.remove('drag-over');
    });

    uploadArea.addEventListener('drop', function (e) {
      e.preventDefault();
      uploadArea.classList.remove('drag-over');
      const file = e.dataTransfer.files[0];
      if (file && file.type.startsWith('image/')) {
        handleFileSelected(file);
      }
    });

    // Click on upload area (excluding button)
    uploadArea.addEventListener('click', function (e) {
      if (e.target === uploadArea || e.target.closest('.upload-icon') || e.target.closest('.upload-text') || e.target.closest('.upload-hint')) {
        input.click();
      }
    });
  });

  // ---- Handle file selection ----
  function handleFileSelected(file) {
    // Validate size (5 MB max)
    if (file.size > 5 * 1024 * 1024) {
      showError('Image trop grande. Veuillez choisir une image de moins de 5 MB.');
      return;
    }

    selectedFile = file;

    // Show preview
    const reader = new FileReader();
    reader.onload = function (e) {
      const previewImg = document.getElementById('preview-img');
      const photoPreview = document.getElementById('photo-preview');
      const uploadArea = document.getElementById('upload-area');
      const btnAnalyze = document.getElementById('btn-analyze');

      if (previewImg) previewImg.src = e.target.result;
      if (photoPreview) photoPreview.classList.remove('hidden');
      if (uploadArea) uploadArea.classList.add('hidden');
      if (btnAnalyze) btnAnalyze.classList.remove('hidden');
    };
    reader.readAsDataURL(file);
  }

  // ---- Analyze photo ----
  window.analyzePhoto = function () {
    if (!selectedFile) return;

    showStep('loading');

    const formData = new FormData();
    formData.append('image', selectedFile);

    fetch(API_URL + '/api/analyze', {
      method: 'POST',
      body: formData
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.error || 'Erreur serveur (' + response.status + ')');
          });
        }
        return response.json();
      })
      .then(function (data) {
        displayResults(data);
      })
      .catch(function (err) {
        console.error('Skin analyzer error:', err);
        showError(err.message || 'Une erreur est survenue. Veuillez réessayer.');
      });
  };

  // ---- Display results ----
  function displayResults(data) {
    // skin_type
    const skinTypeEl = document.getElementById('skin-type-text');
    if (skinTypeEl && data.skin_type) {
      skinTypeEl.textContent = data.skin_type;
    }

    // concerns
    const concernsEl = document.getElementById('concerns-text');
    if (concernsEl && data.concerns) {
      if (Array.isArray(data.concerns)) {
        concernsEl.textContent = data.concerns.join(', ');
      } else {
        concernsEl.textContent = data.concerns;
      }
    }

    // routine
    const routineEl = document.getElementById('routine-text');
    if (routineEl && data.routine) {
      if (Array.isArray(data.routine)) {
        routineEl.textContent = data.routine.join(' • ');
      } else {
        routineEl.textContent = data.routine;
      }
    }

    // recommended_ingredients or products
    const productsEl = document.getElementById('products-text');
    if (productsEl) {
      const ingredients = data.recommended_ingredients || data.key_ingredients || data.products;
      if (ingredients) {
        if (Array.isArray(ingredients)) {
          productsEl.textContent = ingredients.join(', ');
        } else {
          productsEl.textContent = ingredients;
        }
      }
    }

    showStep('results');
  }

  // ---- Show error ----
  function showError(message) {
    const errorEl = document.getElementById('error-message');
    if (errorEl) errorEl.textContent = message;
    showStep('error');
  }

  // ---- Step management ----
  function showStep(stepName) {
    const steps = ['upload', 'loading', 'results', 'error'];
    steps.forEach(function (s) {
      const el = document.getElementById('step-' + s);
      if (el) {
        if (s === stepName) {
          el.classList.remove('hidden');
        } else {
          el.classList.add('hidden');
        }
      }
    });
  }

  // ---- Reset ----
  window.resetAnalyzer = function () {
    selectedFile = null;

    const input = document.getElementById('skin-photo-input');
    const photoPreview = document.getElementById('photo-preview');
    const uploadArea = document.getElementById('upload-area');
    const btnAnalyze = document.getElementById('btn-analyze');

    if (input) input.value = '';
    if (photoPreview) photoPreview.classList.add('hidden');
    if (uploadArea) uploadArea.classList.remove('hidden');
    if (btnAnalyze) btnAnalyze.classList.add('hidden');

    showStep('upload');
  };

})();
